import React from "react";

import {
    NavigationBackProps,
    NavigationBackState
} from "./models";

import {
    RouteComponentProps,
    withRouter
} from "react-router-dom";

import {
    Box,
    Fab
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

class NavigationBack extends React.Component<NavigationBackProps & RouteComponentProps<any>, NavigationBackState> {

    handleGoBack = () => {
        const { backRoute, history } = this.props;

        if (backRoute) {
            history.push(backRoute);
        } else {
            history.goBack();
        }
    };

    render() {
        return (<>
            <Box className={"w-100"} textAlign={"left"} onClick={this.handleGoBack}>
                <Fab color="primary" size="small">
                    <ArrowBackIcon sx={{color: process.env.REACT_APP_BACKGROUND_COLOR}}/>
                </Fab>
            </Box>
        </>);
    }
}

export default withRouter(NavigationBack);
